import { Box, Dialog, DialogTitle, styled } from '@mui/material';
import Button from '@mui/material/Button';

export const StyledDialog = styled(Dialog)`
  & .MuiDialog-container {
    height: 620px;
  }
  & .MuiDialog-paper {
    background: white;
    padding: 50px;
    height: 600px;
    width: 800px;
    border-radius: 20px;
    box-shadow: 0 3px 75px 0 rgba(0, 0, 0, 0.5);
    color: #082940;
    font-family: Roboto;
    font-size: 18px;
    justify-content: center;
  },
& .MuiDialogContent-root {
  padding: 0px;
     textAlign: center;
     whiteSpace: pre-line;
},
& .MuiDialogActions-root{
  display: flex;
  justify-content: center;
},
`;

export const StyledDialogTitle = styled(DialogTitle)`
    margin: 0;
    padding-bottom: 20px;
    text-align: center;
    font-family: Roboto;
    font-size: 25px;
    line-height: 28px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

export const StyledCancelButton = styled(Button)`
    border-radius: 25px;
    border: 1px solid #245f88;
    padding: 16px 30px;
    letter-spacing: 0;
    text-transform: none;
    height: 50px;
    font-size: 15px;
    line-height: 18px;
    white-space: nowrap;
    color: #082940;
`;

export const StyledSaveButton = styled(Button)`
    border-radius: 25px;
    border: 1px solid #245f88;
    padding: 16px 30px;
    letter-spacing: 0;
    text-transform: none;
    height: 50px;
    font-size: 15px;
    line-height: 18px;
    white-space: nowrap;
    color: white;
    margin-left: 15px !important;
`;

export const StyledBox = styled(Box)`
    height: 50px;
    width: 275px;
    margin-top: 15px;
    border-radius: ${({ theme }) => theme.shape.borderRadiusLarge}px;
    background-color: #082940;
    display: flex;
    align-items: center;
`;

export const StyledOpenButton = styled(Button)`
    border-color: white;
    &.modified {
        border-color: ${({ theme }) => theme.palette.warning.main};
    }
    color: white;
    border-radius: 25px;
    border-width: 0.4px;
    border-style: solid;
    width: 20px;
    padding: 16px 30px;
    letter-spacing: 0;
    text-transform: none;
    height: 50px;
    font-size: 15px;
    line-height: 18px;
    white-space: nowrap;
`;
